export default {
	text: "{changedBy} renamed the KR <span class='text-strike'><a href='#' data-action='key-result'>{from}</a></span> to <a href='#' data-action='key-result'>{to}</a>",
};
